import styled from "styled-components";
import {green, qaLink} from "../../styles/constants";
import {Col, Container, Row} from "react-bootstrap";
import React from "react";

const Wrapper = styled.div`
  background-color: ${green};
  color: white;
`;

const Title = styled.span`
  font-weight: 600;
`;

const P = styled.p`
  color: white;
`;

const A = styled.a`
  color: white;
  text-decoration: underline;
`;


const UpdateBar = () => {
  return (
    <Wrapper className="pt-3">
      <Container>
        <Row>
          <Col>
              <Title>Update: De Bloeibogen tool is bijgewerkt per 31 juli!</Title>
              <P>De verspreidings- en interactiemodellen zijn geüpdatet. Lees er meer over in <A
                href={qaLink}
                target="_blank"
                rel="noreferrer"
              >
                deze Q&A
              </A>.</P>
          </Col>
        </Row>
      </Container>
    </Wrapper>
  )
}

export default UpdateBar